export default {
    install(Vue) {
        Vue.prototype.$route = (...args) => route(...args).url();

        Vue.prototype.$routeName = () => route().current();

        Vue.prototype.$isRoute = (routeName, routeArgs) => {
            if (!routeArgs) return route().current(routeName, routeArgs);

            return route().current(routeName, routeArgs) && Object.entries(route().params)
                .filter(([key]) => routeArgs.hasOwnProperty(key))
                .every(([key, value]) => routeArgs[key] == value);
        };
    },
};
